<!-- =============================================
     FULL PAGE CART SECTION
============================================= -->
<app-navbar-style-two></app-navbar-style-two>
<div class="p-4 bg-dark"  style="margin-top: -90px;"></div>
<section class="cart-page">

  <!-- Background Shapes -->
  <div class="cart-bg-shape shape1"></div>
  <div class="cart-bg-shape shape2"></div>

  <div class="container-fluid">

    <!-- CART HEADER -->
    <div class="cart-page-header">

      <div class="cart-header-left">
        <span class="cart-badge">SHOPPING CART</span>
        <h1>Your Cart</h1>
      </div>

      <div class="cart-header-right">
        <div class="cart-count-box">
          <i class='bx bx-cart'></i>
          <span>{{ totalQuantity }} Items</span>
        </div>
      </div>

    </div>

    <!-- EMPTY CART -->
<div *ngIf="cartItems.length === 0"
     class="full-empty-cart-wrapper">

    <div class="empty-cart">

        <div class="empty-cart-icon">
            <i class='bx bx-cart-alt'></i>
        </div>

        <h3>Your cart is empty</h3>

        <p>
            Looks like you haven’t added anything yet.
        </p>

        <button class="continue-shopping-btn"   routerLink="/product-menu">
            Continue Shopping
        </button>

    </div>

</div>

<!-- CART LAYOUT -->
<div class="cart-layout"
     *ngIf="cartItems.length > 0">

    <!-- LEFT SIDE -->
    <div class="cart-products-section">

        <div class="cart-item"
             *ngFor="let item of cartItems; let i = index">

            <!-- IMAGE -->
            <div class="item-image">
                <img [src]="item.image"
                     [alt]="item.title"
                     (error)="$event.target.src='assets/img/whiteimage.jpg'">
            </div>

            <!-- DETAILS -->
            <div class="item-details">

                <h3 class="item-title">
                    {{ item.title }}
                </h3>

               

                <div class="item-meta">

                    <div class="item-price">
                        ${{ item.price }}
                    </div>

                    <div class="quantity-controls">

                        <button class="quantity-btn"
                                (click)="updateQuantity(i, item.quantity - 1)"
                                [disabled]="item.quantity <= 1">

                            <i class='bx bx-minus'></i>

                        </button>

                        <span class="quantity">
                            {{ item.quantity }}
                        </span>

                        <button class="quantity-btn"
                                (click)="updateQuantity(i, item.quantity + 1)">

                            <i class='bx bx-plus'></i>

                        </button>

                    </div>

                </div>

            </div>

            <!-- RIGHT -->
            <div class="item-right-section">

                <button class="remove-item-btn"
                        (click)="removeItem(i)">

                    <i class='bx bx-trash'></i>

                </button>

                <div class="item-total">
                    ${{ (item.price * item.quantity) | number:'1.2-2' }}
                </div>

            </div>

        </div>

    </div>

    <!-- RIGHT SIDE -->
    <div class="cart-summary-section">

        <div class="summary-card">

            <div class="summary-header">
                <h3>Order Summary</h3>
            </div>

            <div class="summary-body">

                <div class="summary-row">
                    <span>Subtotal</span>
                    <span>${{ calculateTotal() | number:'1.2-2' }}</span>
                </div>

                <div class="summary-row">
                    <span>Shipping</span>
                    <span>Free</span>
                </div>

                <div class="summary-row">
                    <span>Tax</span>
                    <span>${{ calculateTax() | number:'1.2-2' }}</span>
                </div>

                <div class="summary-divider"></div>

                <div class="summary-row total">
                    <span>Total</span>
                    <span>${{ calculateTotalWithTax() | number:'1.2-2' }}</span>
                </div>

                <button class="checkout-btn"
                        (click)="openOrderModal()">

                    <i class='bx bx-lock-alt'></i>
                    Proceed To Checkout

                </button>

                <div class="secure-checkout">
                    <i class='bx bx-shield-quarter'></i>
                    Secure Checkout
                </div>

            </div>

        </div>

    </div>

</div>
  </div>

</section> 

<app-checkout-modal [show]="showCheckout" [orderData]="orderData" (close)="showCheckout=false">
</app-checkout-modal>


